import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { rem, Flex, Image, Text, Spoiler, Divider } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { CalenderIcon, LocationIcon, TimerIcon } from "assets/icon";
import CalenderImage from "../../assets/icon/Calender-icon.png";
import LocationImage from "../../assets/icon/Location-icon.png";
import { Loader } from "components";
import { TwShowMore } from "components/tailwind";
import { FiExternalLink } from "react-icons/fi";
import { SELLER_REF } from "constants";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import logger from "utils/logger";

dayjs.extend(advancedFormat);

export default function EventInfoCard({
  reduxstate,
  selectedStep,
  isReview,
  isReadMore,
  toggleReadMore,
}) {
  const { t } = useTranslation();
  const sellerRef = window.localStorage.getItem(SELLER_REF);

  if (!reduxstate.eventData) {
    return <Loader size={40} />;
  }

  // console.log("reduxstate", reduxstate);
  const sellerdetail = sellerRef && sellerRef !== "" ? reduxstate?.eventData?.salesChannelList?.find((f) => f.sellerReferenceId == sellerRef) : {};
  const eventImage = sellerRef && sellerRef !== "" && sellerdetail && sellerdetail?.bannerImage && sellerdetail?.bannerImage !== "" ? sellerdetail?.bannerImage : reduxstate?.eventData?.eventDetail?.eventPhoto;
  const eventName = reduxstate?.eventData?.eventDetail?.eventName;
  const schoolLogo =
    reduxstate?.eventData?.businessDetail?.myBusinessProfile?.logo;
  const schoolName =
    reduxstate?.eventData?.businessDetail?.myBusinessProfile?.businessName;
  const where = reduxstate?.location;
  const description = reduxstate?.eventData?.eventDetail?.description;
  const tagLine = reduxstate?.eventData?.eventDetail?.tagLines;

  // console.log("tagLine", tagLine);

  // New design for review mode
  if (isReview) {
    return (
      <div
        className="w-full flex gap-4 items-center p-4 shadow-md"
      >
        <img
          src={eventImage}
          alt=""
          className="inline-block size-20 rounded-md"
        />
        <div className="flex flex-col gap-1">
          <div className="text-lg font-bold line-clamp-1">
            {eventName}
          </div>
          <div className="text-sm font-semibold line-clamp-1">
            {dayjs(reduxstate?.eventDate).format("ddd, MMM D")} •{" "}
            {`${dayjs(reduxstate?.eventDate).format("HH:mm")} - ${dayjs(
              reduxstate?.eventEndDate
            ).format("HH:mm")}`}
          </div>
          <div className="flex gap-2 items-center">
            <img
              src={LocationImage}
              alt="Location Icon"
              className="w-4"
            />
            <div className="text-sm text-gray-500 line-clamp-1">
              {where?.addressName}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="border-b-2 border-gray-200">
      <div className="p-4">
        <img
          src={eventImage}
          alt={""}
          className="aspect-[4/2] w-full rounded-2xl object-cover"
        />
        <div className="p-4">
          <div className="flex flex-col gap-1" gap={rem(4)}>
            <div className="text-2xl font-bold">
              {eventName}
            </div>

            <div className="flex flex-row gap-5">
              <div className="flex flex-row gap-2 items-center">
                <img
                  src={schoolLogo}
                  alt={"Host"}
                  className="size-6 rounded-full"
                />
                <div className="flex flex-row gap-1 justify-start items-center text-neutral-800">
                  <div className="text-xs truncate">
                    {t("common.hostedBy")}
                  </div>
                  <div
                    className="flex-1 text-xs font-bold line-clamp-1"
                  >
                    {schoolName}
                  </div>
                  <div
                    className="text-xs font-normal"
                  >
                    {sellerRef && sellerRef !== "" && sellerdetail && sellerdetail?.sellerId && sellerdetail?.channeltype && ["individual_reseller", "venue_box_office", "influencer", "promotion_company"].indexOf(sellerdetail?.channeltype) >= 0 ? "(" + (sellerdetail?.name || "") + ")" : ""}
                  </div>
                </div>
              </div>
            </div>
            {selectedStep >= 1 && (
              <div className="flex flex-col gap-6 mt-4" direction="column" mb={rem(20)}>
                <div className="flex flex-row gap-3">
                  <div className="mt-1.5 size-12 flex flex-col border border-gray-300 text-center rounded-lg text-black ">
                    {/* <img
                      src={CalenderImage}
                      alt="Calendar Icon"
                      className="w-5"
                    /> */}
                    <div className="text-xs bg-gray-300 p-0.5  rounded-t-md">
                      {dayjs(reduxstate?.eventDate).format(
                        "MMM"
                      )}
                    </div>
                    <div className="flex-1">
                      {dayjs(reduxstate?.eventDate).format(
                        "D"
                      )}
                    </div>
                  </div>
                  <div className="flex-1 flex flex-col gap-0">
                    <div className="text-lg font-bold line-clamp-1">
                      {dayjs(reduxstate?.eventDate).format(
                        "dddd, MMMM D YYYY"
                      )}
                    </div>
                    <div className="text-sm text-gray-500 pl-0.5">
                      {`${dayjs(reduxstate?.eventDate).format(
                        "HH:mm"
                      )} - ${dayjs(reduxstate?.eventEndDate).format(
                        "HH:mm"
                      )} (GMT${dayjs(reduxstate?.eventDate)
                        .format("Z")
                        .replace(":00", "")})`}
                    </div>
                  </div>
                </div>
                <div className="flex flex-row gap-3 cursor-pointer" onClick={() => {
                  logger.log("where.address", where);
                  if (where?.location?.coordinates) {
                    window.open(`https://www.google.com/maps/search/?api=1&query=${where?.location?.coordinates.join(",")}`)
                  }
                }}>
                  <div className="mt-1.5 size-12 flex flex-col items-center justify-center border border-gray-300 text-center rounded-lg">
                    <img
                      src={LocationImage}
                      alt="Location Icon"
                      className="w-6"
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-0">
                    <div className="text-lg font-bold line-clamp-1 flex gap-2 items-center">{where.addressName} <FiExternalLink className="text-gray-500"></FiExternalLink></div>
                    <div className="text-sm text-gray-500 pl-0.5">{where.address}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* {selectedStep > 1 && (
          <Flex mt="xl" direction="column">
            <div className="item">
              <div className="icon">
                <LocationIcon />
              </div>
              <div className="meta">
                <div className="lbl">Where</div>
                <div className="value">{where.addressName}</div>
                <div className="text">{where.address}</div>
              </div>
            </div>
            <div className="item">
              <div className="icon">
                <TimerIcon />
              </div>
              <div className="meta">
                <div className="lbl">When</div>
                <div className="value">
                  {`${dayjs(reduxstate?.eventDate).format(
                    "MMM Do, YYYY, h:mm a"
                  )} - ${dayjs(reduxstate?.eventEndDate).format("h:mm a")}`}
                </div>
              </div>
            </div>
          </Flex>
        )} */}

      {selectedStep <= 1 && description && (
        <div className="flex flex-col gap-2 p-5">
          <div className="text-lg font-bold">{t("common.aboutEvent")}</div>
          <div className="text-base">
            <TwShowMore>
              <div className="" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}></div>
            </TwShowMore>
            {/* <Spoiler
              className="!h-24"
              minHeight={60}
              maxHeight={45}
              showLabel={<span className="read-or-hide text-secondary">Read more</span>}
              hideLabel={<span className="read-or-hide text-secondary">Show less</span>}
            >
              {description}
            </Spoiler> */}
          </div>
        </div>
      )}
    </div>
  );
}
